import { render, staticRenderFns } from "./LifeCareReverse.vue?vue&type=template&id=2ce563d6&scoped=true"
import script from "./LifeCareReverse.vue?vue&type=script&lang=js"
export * from "./LifeCareReverse.vue?vue&type=script&lang=js"
import style0 from "./LifeCareReverse.vue?vue&type=style&index=0&id=2ce563d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce563d6",
  null
  
)

export default component.exports